import ModalCard from "@/app/components/ModalCard";
import SendRequestButton from "@/app/components/RequestButton";
import RequestForm from "@/app/components/ServiceRequestForm";
import { Service } from "@/lib/api/types";
import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";

const ServiceConsultation = ({
  userId,
  userName,
  services,
}: {
  userId: string;
  userName: string;
  services: Service[];
}) => {
  const [isRequestFormActive, setRequestFormActive] = React.useState(false);

  return (
    <>
      <Paragraph>
        The following services require a consultation before booking. Please
        submit a request form to schedule a mini consultation:
      </Paragraph>
      <Paragraph>
        <ul
          style={{
            listStyleType: "square",
            color: "black",
          }}
        >
          {services.map((service) => (
            <li key={service.title}>{service.title}</li>
          ))}
        </ul>
      </Paragraph>

      <SendRequestButton onClick={() => setRequestFormActive(true)} />

      {/* {isRequestFormActive && ( */}
      <ModalCard
        destroyOnClose={true}
        open={isRequestFormActive}
        title="Service request"
        onClose={() => {
          setRequestFormActive(false);
        }}
      >
        <RequestForm
          userId={userId}
          userName={userName}
          services={services}
          onClose={() => setRequestFormActive(false)}
        />
      </ModalCard>
      {/* )} */}
    </>
  );
};

export default ServiceConsultation;
